import { ProgramAccount } from "@project-serum/anchor";
import { PublicKey } from "@solana/web3.js";
export const getPublicKeys = (page:number, perPage: number, allPublicKeys: PublicKey[]) => {
        
    const publicKeys = allPublicKeys.slice(0 , page * perPage);
    return publicKeys;
  }

  export const getTweets = (page:number, perPage: number, allPublicKeys: any) => {
        
    const Tweets = allPublicKeys.slice(0 , page * perPage);
    return Tweets;
  }